import * as React from 'react';

/**
 * @description China icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { China } from '@sravni/design-system-icons'
 *
 * <China />
 * ```
 */
const China = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "China", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#China__a)" },
        React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#EE1C25" }),
        React.createElement("path", { d: "m6.81 5.688 2.355 7.09L3 8.395h7.62l-6.165 4.381M14.01 4.486l-.223 2.475-1.306-2.13 2.337.972-2.475.557M17.117 7.391l-1.188 2.197-.359-2.46 1.769 1.783-2.503-.425M17.412 11.772l-2 1.531.698-2.389.87 2.334-2.106-1.387M13.958 13.61l-.118 2.482-1.396-2.075 2.377.876-2.45.657", fill: "#FF0" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "China__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))));

export { China };
//# sourceMappingURL=China.js.map
